module.exports = "/_next/static/images/hypurr-logo-680d99c369a57fcfc286ce8709fcb7f3.svg";